<p *ngIf="showMessage && !summaryData.HasPinsheet && !summaryData.HasError" class="hidepinsheet">No pinsheet generated for this day</p>
<p *ngIf="summaryData.HasError" class="hidepinsheet">{{summaryData.ErrorMessage}}</p>
<div *ngIf="!(has27Green && isGroupedCourse) && !(has36Green && isGroupedCourse) && !isMultiplePinsheetCourse" id="eighteenGreen" [ngClass]="{'pin-table-container' : page == 'pinsheet' && !user && showTables}" #has18Grid>
    <mat-grid-list cols="{{cols}}" rowHeight="{{rowHeight}}" gutterSize="-1px" [ngClass]="{'reduce-grid-width' : page == 'pinsheet' && !user && showTables, 'disable-pointer-events': isClubCarClient}" >
        <div *ngIf="summaryData.HasPinsheet">
            <mat-grid-tile *ngFor="let green of summaryData.GreenList" [ngClass]="{'selected': (selectedGreen === green.Name && isApacheCourse && isShowDetails)}" (click)="redirectPinsheetDetails()" >
                <div class="green" [attr.data-greenname]="green.Id" [ngClass]="{'reduce-font-size': page == 'pinsheet' && !user && showTables}">
                    <img src="{{'data:image/jpg;base64,'+green.Image}}" class="green_image eighteen_green"
                        [routerLink]="getPinsheetDetailsLink(green.PinsheetID, green.Id, courseList[0].CourseID)"
                        [queryParams]="page!='externalPinsheet' ? {} : {accessKey: externalAccessKey}">
                    <div class="green_holeid ">
                        <p [ngClass]="{'highlight': green.HasEdgeHole && page!='externalPinsheet' && selectedHoleLayoutTypeId!= 2 && selectedHoleLayoutTypeId != 3,
                                       'forced': colorIndication && (green.EdgeHoleSelectionReason == 'Forced' || green.EdgeHoleSelectionReason == 'LimitForced'),
                                       'manual': colorIndication && green.EdgeHoleSelectionReason == 'Manual',
                                       'grey-dotted-circle': colorIndication && green.EdgeHoleSelectionReason == 'LimitReverted',
                                       'pointer': page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null}"
                            [tooltip]="(page!='externalPinsheet' && colorIndication && isDesktop) ? getEdgeHoleTooltipMessage[green.EdgeHoleSelectionReason] : null"
                            [tooltipPlacement]="'auto'"
                            [container]="'body'"
                            [containerClass]="'color-indication-tooltip'"
                            (click)="(page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null) ? openColorIndicationLegendDialog() : null">
                            {{green.Name}}
                        </p>
                    </div>
                    <div class="green_position">
                        <p>D: {{green.Depth}}
                        </p>
                    </div>
                    <div class="green_holecenter">
                        <p>{{green.Center || 'X'}}
                        </p>
                    </div>
                    <div class="hole_pos">
                        <p *ngIf="green.Position != null ||  green.Position !=''">{{green.Position}}</p>
                        <p *ngIf="green.Position == null ||  green.Position ==''" style="color:rgb(192,0,0);">
                            {{'Select Hole'}}</p>
                    </div>
                    <div [style]="{ position: 'absolute', top: 25 + (5 - getGreenTeeBoxes(green.Id).length) * 5 + '%', left: 0 }" *ngIf="teeBoxData.length> 0 && showTeeBoxDistance && green.Position != null && green.Position != ''">
                        <table style="border: 1px solid black;">
                            <tr *ngFor="let teeBox of getGreenTeeBoxes(green.Id)">
                                <p style="color: #01395d; font-size: min(2.4vw, 0.75rem); padding: 0px 1px; margin: 0px; line-height: min(4vw, 20px);" *ngIf="teeBox.IsActive">{{getTeeBoxDistance(teeBox.Distance, green.Center)}}</p>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="hole_stimp" *ngIf="page == 'pinsheet' && !user && green.Position && showStimp" [ngStyle]="{'background-color': green.StimpColor}">
                    <p>
                        {{green.StimpValue}}%
                    </p>
                </div>
                <div *ngIf="isApacheCourse" class="details" (click)="showDetails(green.Name, 'zoneDetails-1')">
                    <p>Details</p>
                </div>
            </mat-grid-tile>
        </div>
    </mat-grid-list>
    <div class="hole-tables" *ngIf="page == 'pinsheet' && showTables">
        <div *ngIf="isApacheCourse" class="green-details-container" id="zoneDetails-1"  style="display: none;">
            <p class="green-details-heading">GREEN {{hoveredGreenName}}</p>
            <div class="green-text-container">
                <div>
                    <p class="green-text" >MOISTURE</p>
                    <p class="green-values">{{moistureValue}} %</p>
                </div>
                <div>
                    <p class="green-text" >EC</p>
                    <p class="green-values">{{ecValue}} dS/m</p>
                </div>
                <div>
                    <p class="green-text" >SALINITY INDEX</p>
                    <p class="green-values">{{salinityIndexValue}}</p>
                </div>
                <div>
                    <p class="green-text" >SURFACE HEAT</p>
                    <p class="green-values">{{surfaceHeatValue}} F</p>
                </div>
                <div>
                    <p class="green-text" >SOIL TEMP</p>
                    <p class="green-values">{{soilTempValue}} F</p>
                </div>
            </div>
        </div>
        <app-hole-position-tables *ngIf="page == 'pinsheet' && !user && showTables" 
            [hasPinsheet]="summaryData.HasPinsheet" [greenList]="summaryData.GreenList">
        </app-hole-position-tables>
    </div>
</div>
<div *ngIf="isMultiplePinsheetCourse" id="multipleGreen" #has18Grid>
    <p *ngIf="summaryData.HasPinsheet || primaryGreens.length > 0" class="pinsheet_title">Primary Greens</p>
    <div [ngClass]="{'pin-table-container' : page == 'pinsheet' && !user && showTables}">
        <mat-grid-list cols="{{cols}}" rowHeight="{{rowHeight}}" gutterSize="-1px" *ngIf="primaryGreens.length >0" [ngClass]="{'reduce-grid-width' : page == 'pinsheet' && !user && showTables, 'disable-pointer-events': isClubCarClient}">
            <div *ngIf="summaryData.HasPinsheet">
                <mat-grid-tile *ngFor="let green of primaryGreens"  [ngClass]="{'selected': (selectedGreen === green.Name && isApacheCourse && isShowDetails)}" (click)="redirectPinsheetDetails()" >
                    <div class="green" [attr.data-greenname]="green.Id" [ngClass]="{'reduce-font-size': page == 'pinsheet' && !user && showTables}">
                        <img src="{{'data:image/jpg;base64,'+green.Image}}" class="green_image "
                            [routerLink]="getPinsheetDetailsLink(green.PinsheetID, green.Id, courseList[0].CourseID)"
                            [queryParams]="page!='externalPinsheet' ? {} : {accessKey: externalAccessKey}">
                        <div class="green_holeid ">
                            <p [ngClass]="{'highlight': green.HasEdgeHole && page!='externalPinsheet',
                                           'forced': colorIndication && (green.EdgeHoleSelectionReason == 'Forced' || green.EdgeHoleSelectionReason == 'LimitForced'),
                                           'manual': colorIndication && green.EdgeHoleSelectionReason == 'Manual',
                                           'grey-dotted-circle': colorIndication && green.EdgeHoleSelectionReason == 'LimitReverted',
                                           'pointer': page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null}"
                                [tooltip]="(page!='externalPinsheet' && colorIndication && isDesktop) ? getEdgeHoleTooltipMessage[green.EdgeHoleSelectionReason] : null"
                                [tooltipPlacement]="'auto'"
                                [container]="'body'"
                                [containerClass]="'color-indication-tooltip'"
                                (click)="(page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null) ? openColorIndicationLegendDialog() : null">
                                {{green.Name}}
                            </p>
                        </div>
                        <div class="green_position">
                            <p>D: {{green.Depth}}
                            </p>
                        </div>
                        <div class="green_holecenter">
                            <p>{{green.Center || 'X'}}
                            </p>
                        </div>
                        <div class="hole_pos">
                            <p *ngIf="green.Position != null ||  green.Position !=''">{{green.Position}}</p>
                            <p *ngIf="green.Position == null ||  green.Position ==''" style="color:rgb(192,0,0);">
                                {{'Select Hole'}}</p>
                        </div>
                        <div [style]="{ position: 'absolute', top: 25 + (5 - getGreenTeeBoxes(green.Id).length) * 5 + '%', left: 0 }" *ngIf="teeBoxData.length> 0 && showTeeBoxDistance && green.Position != null && green.Position != ''">
                            <table style="border: 1px solid black;">
                                <tr *ngFor="let teeBox of getGreenTeeBoxes(green.Id)">
                                    <p style="color: #01395d; font-size: min(2.4vw, 0.75rem); padding: 0px 1px; margin: 0px; line-height: min(4vw, 20px);" *ngIf="teeBox.IsActive">{{getTeeBoxDistance(teeBox.Distance, green.Center)}}</p>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="hole_stimp" *ngIf="page == 'pinsheet' && !user && green.Position && showStimp" [ngStyle]="{'background-color': green.StimpColor}">
                        <p>
                            {{green.StimpValue}}%
                        </p>
                    </div>
                    <div *ngIf="isApacheCourse" class="details" (click)="showDetails(green.Name, 'zoneDetails-2')">
                        <p>Details</p>
                    </div>
                </mat-grid-tile>
            </div>
        </mat-grid-list>
        <div class="hole-tables" *ngIf="page == 'pinsheet' && showTables">
            <div *ngIf="isApacheCourse" class="green-details-container" id="zoneDetails-2"  style="display: none;">
                <p class="green-details-heading">GREEN {{hoveredGreenName}}</p>
                <div class="green-text-container">
                    <div>
                        <p class="green-text" >MOISTURE</p>
                        <p class="green-values">{{moistureValue}} %</p>
                    </div>
                    <div>
                        <p class="green-text" >EC</p>
                        <p class="green-values">{{ecValue}} dS/m</p>
                    </div>
                    <div>
                        <p class="green-text" >SALINITY INDEX</p>
                        <p class="green-values">{{salinityIndexValue}}</p>
                    </div>
                    <div>
                        <p class="green-text" >SURFACE HEAT</p>
                        <p class="green-values">{{surfaceHeatValue}} F</p>
                    </div>
                    <div>
                        <p class="green-text" >SOIL TEMP</p>
                        <p class="green-values">{{soilTempValue}} F</p>
                    </div>
                </div>
            </div>
            <app-hole-position-tables *ngIf="page == 'pinsheet' && !user && showTables" class="hole-tables" 
                [hasPinsheet]="summaryData.HasPinsheet" [greenList]="primaryGreens">
            </app-hole-position-tables>
        </div>
    </div>
    <p *ngIf="summaryData.HasPinsheet" class="pinsheet_title">Secondary Greens</p>
    <div [ngClass]="{'pin-table-container' : page == 'pinsheet' && !user && showTables}">
        <mat-grid-list cols="{{cols}}" rowHeight="{{rowHeight}}" gutterSize="-1px" [ngClass]="{'reduce-grid-width' : page == 'pinsheet' && !user && showTables, 'disable-pointer-events': isClubCarClient}">
            <div *ngIf="summaryData.HasPinsheet">
                <mat-grid-tile *ngFor="let green of secondaryGreens"  [ngClass]="{'selected': (selectedGreen === green.Name && isApacheCourse && isShowDetails)}" (click)="redirectPinsheetDetails()" >
                    <div class="green" [attr.data-greenname]="green.Id" [ngClass]="{'reduce-font-size': page == 'pinsheet' && !user && showTables}">
                        <img src="{{'data:image/jpg;base64,'+green.Image}}" class="green_image "
                            [routerLink]="getPinsheetDetailsLink(green.PinsheetID, green.Id, courseList[0].CourseID)"
                            [queryParams]="page!='externalPinsheet' ? {} : {accessKey: externalAccessKey}">
                        <div class="green_holeid ">
                            <p [ngClass]="{'highlight': green.HasEdgeHole && page!='externalPinsheet',
                                           'forced': colorIndication && (green.EdgeHoleSelectionReason == 'Forced' || green.EdgeHoleSelectionReason == 'LimitForced'),
                                           'manual': colorIndication && green.EdgeHoleSelectionReason == 'Manual',
                                           'grey-dotted-circle': colorIndication && green.EdgeHoleSelectionReason == 'LimitReverted',
                                           'pointer': page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null}"
                                [tooltip]="(page!='externalPinsheet' && colorIndication && isDesktop) ? getEdgeHoleTooltipMessage[green.EdgeHoleSelectionReason] : null"
                                [tooltipPlacement]="'auto'"
                                [container]="'body'"
                                [containerClass]="'color-indication-tooltip'"
                                (click)="(page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null) ? openColorIndicationLegendDialog() : null">
                                {{green.Name}}
                            </p>
                        </div>
                        <div class="green_position">
                            <p>D: {{green.Depth}}
                            </p>
                        </div>
                        <div class="green_holecenter">
                            <p>{{green.Center || 'X'}}
                            </p>
                        </div>
                        <div class="hole_pos">
                            <p *ngIf="green.Position != null ||  green.Position !=''">{{green.Position}}</p>
                            <p *ngIf="green.Position == null ||  green.Position ==''" style="color:rgb(192,0,0);">
                                {{'Select Hole'}}</p>
                        </div>
                        <div [style]="{ position: 'absolute', top: 25 + (5 - getGreenTeeBoxes(green.Id).length) * 5 + '%', left: 0 }" *ngIf="teeBoxData.length> 0 && showTeeBoxDistance && green.Position != null && green.Position != ''">
                            <table style="border: 1px solid black;">
                                <tr *ngFor="let teeBox of getGreenTeeBoxes(green.Id)">
                                    <p style="color: #01395d; font-size: min(2.4vw, 0.75rem); padding: 0px 1px; margin: 0px; line-height: min(4vw, 20px);" *ngIf="teeBox.IsActive">{{getTeeBoxDistance(teeBox.Distance, green.Center)}}</p>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="hole_stimp" *ngIf="page == 'pinsheet' && !user && green.Position && showStimp" [ngStyle]="{'background-color': green.StimpColor}">
                        <p>
                            {{green.StimpValue}}%
                        </p>
                    </div>
                    <div *ngIf="isApacheCourse" class="details" (click)="showDetails(green.Name, 'zoneDetails-3')">
                        <p>Details</p>
                    </div>
                </mat-grid-tile>
            </div>
        </mat-grid-list>
        <div class="hole-tables" *ngIf="page == 'pinsheet' && showTables">
            <div *ngIf="isApacheCourse" class="green-details-container" id="zoneDetails-3"  style="display: none;">
                <p class="green-details-heading">GREEN {{hoveredGreenName}}</p>
                <div class="green-text-container">
                    <div>
                        <p class="green-text" >MOISTURE</p>
                        <p class="green-values">{{moistureValue}} %</p>
                    </div>
                    <div>
                        <p class="green-text" >EC</p>
                        <p class="green-values">{{ecValue}} dS/m</p>
                    </div>
                    <div>
                        <p class="green-text" >SALINITY INDEX</p>
                        <p class="green-values">{{salinityIndexValue}}</p>
                    </div>
                    <div>
                        <p class="green-text" >SURFACE HEAT</p>
                        <p class="green-values">{{surfaceHeatValue}} F</p>
                    </div>
                    <div>
                        <p class="green-text" >SOIL TEMP</p>
                        <p class="green-values">{{soilTempValue}} F</p>
                    </div>
                </div>
            </div>
            <app-hole-position-tables *ngIf="page == 'pinsheet' && !user && showTables" class="hole-tables" 
                [hasPinsheet]="summaryData.HasPinsheet" [greenList]="secondaryGreens">
            </app-hole-position-tables>
        </div>
    </div>
</div>
<div *ngIf="has27Green && isGroupedCourse" id="has27Green" class="specialPinsheetGrid" [ngClass]="{'single-grid' : page == 'pinsheet' && !user}">
    <div class="marginRight10">
        <div  *ngIf="summaryData.HasPinsheet" class="grid-title">
            <p class="pinsheet_title">{{courseList[0].CourseName}}</p>
            <div class="dv-edge-greens">
                <p class="pinsheet_title" *ngIf="page == 'pinsheet' && !user">Distance Variance : {{summaryData.DistanceVariance[0]}}</p>
                <!-- <app-day-stimp-range class="edge-green-limit" [inputValue]="courseList[0].EdgeGreensLimit"
                    (updatedValue)="updateEdgeGreensLimit($event, courseList[0].CourseId)" [label]="'EDGE GREENS'"
                    [steps]="1" [page]="'grid'" color="white">
                </app-day-stimp-range> -->
            </div>
        </div>
        <div [ngClass]="{'pin-table-container' : page == 'pinsheet' && !user && showTables}">
            <mat-grid-list cols="3" rowHeight="{{rowHeight}}" gutterSize="-1px" [ngClass]="{'reduce-grid-width' : page == 'pinsheet' && !user && showTables, 'disable-pointer-events': isClubCarClient}">
                <div *ngIf="summaryData.HasPinsheet">
                    <mat-grid-tile *ngFor="let green of has27Course1" [ngClass]="{'selected': (selectedGreen === green.Name && isApacheCourse && isShowDetails)}" (click)="redirectPinsheetDetails()">
                        <div class="green" [attr.data-greenname]="green.Id">
                            <img src="{{'data:image/jpg;base64,'+green.Image}}" class="green_image "
                                [routerLink]="getPinsheetDetailsLink(green.PinsheetID, green.Id, courseList[0].CourseID)"
                                [queryParams]="page!='externalPinsheet' ? {} : {accessKey: externalAccessKey}">
                            <div class="green_holeid ">
                                <p [ngClass]="{'highlight': green.HasEdgeHole && page!='externalPinsheet',
                                               'forced': colorIndication && (green.EdgeHoleSelectionReason == 'Forced' || green.EdgeHoleSelectionReason == 'LimitForced'),
                                               'manual': colorIndication && green.EdgeHoleSelectionReason == 'Manual',
                                               'grey-dotted-circle': colorIndication && green.EdgeHoleSelectionReason == 'LimitReverted',
                                               'pointer': page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null}"
                                    [tooltip]="(page!='externalPinsheet' && colorIndication && isDesktop) ? getEdgeHoleTooltipMessage[green.EdgeHoleSelectionReason] : null"
                                    [tooltipPlacement]="'auto'"
                                    [container]="'body'"
                                    [containerClass]="'color-indication-tooltip'"
                                    (click)="(page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null) ? openColorIndicationLegendDialog() : null">
                                    {{green.Name}}
                                </p>
                            </div>
                            <div class="green_position">
                                <p>D: {{green.Depth}}
                                </p>
                            </div>
                            <div class="green_holecenter">
                                <p>{{green.Center || 'X'}}
                                </p>
                            </div>
                            <div class="hole_pos">
                                <p *ngIf="green.Position != null ||  green.Position !=''">{{green.Position}}</p>
                                <p *ngIf="green.Position == null ||  green.Position ==''"
                                    style="color:rgb(192,0,0);">
                                    {{'Select Hole'}}</p>
                            </div>
                            <div [style]="{ position: 'absolute', top: 25 + (5 - getGreenTeeBoxes(green.Id).length) * 5 + '%', left: 0 }" *ngIf="teeBoxData.length> 0 && showTeeBoxDistance && green.Position != null && green.Position != ''">
                                <table style="border: 1px solid black;">
                                    <tr *ngFor="let teeBox of getGreenTeeBoxes(green.Id)">
                                        <p style="color: #01395d; font-size: min(2.4vw, 0.75rem); padding: 0px 1px; margin: 0px; line-height: min(4vw, 20px);" *ngIf="teeBox.IsActive">{{getTeeBoxDistance(teeBox.Distance, green.Center)}}</p>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="hole_stimp" *ngIf="page == 'pinsheet' && !user && green.Position && showStimp" [ngStyle]="{'background-color': green.StimpColor}">
                            <p>
                                {{green.StimpValue}}%
                            </p>
                        </div>
                        <div *ngIf="isApacheCourse" class="details" (click)="showDetails(green.Name, 'zoneDetails-4')">
                            <p>Details</p>
                        </div>
                    </mat-grid-tile>
                </div>
            </mat-grid-list>
            <div class="hole-tables" *ngIf="page == 'pinsheet' && showTables">
                <div *ngIf="isApacheCourse" class="green-details-container" id="zoneDetails-4"  style="display: none;">
                    <p class="green-details-heading">GREEN {{hoveredGreenName}}</p>
                    <div class="green-text-container">
                        <div>
                            <p class="green-text" >MOISTURE</p>
                            <p class="green-values">{{moistureValue}} %</p>
                        </div>
                        <div>
                            <p class="green-text" >EC</p>
                            <p class="green-values">{{ecValue}} dS/m</p>
                        </div>
                        <div>
                            <p class="green-text" >SALINITY INDEX</p>
                            <p class="green-values">{{salinityIndexValue}}</p>
                        </div>
                        <div>
                            <p class="green-text" >SURFACE HEAT</p>
                            <p class="green-values">{{surfaceHeatValue}} F</p>
                        </div>
                        <div>
                            <p class="green-text" >SOIL TEMP</p>
                            <p class="green-values">{{soilTempValue}} F</p>
                        </div>
                    </div>
                </div>
                <app-hole-position-tables *ngIf="page == 'pinsheet' && !user && showTables" class="hole-tables" 
                    [hasPinsheet]="summaryData.HasPinsheet" [greenList]="has27Course1">
                </app-hole-position-tables>
            </div>
        </div>
    </div>
    <div>
        <div *ngIf="summaryData.HasPinsheet" class="grid-title">
            <p class="pinsheet_title">{{courseList[1].CourseName}}</p>
            <div class="dv-edge-greens">
                <p class="pinsheet_title" *ngIf="page == 'pinsheet' && !user">Distance Variance : {{summaryData.DistanceVariance[1]}}</p>
                <!-- <app-day-stimp-range class="edge-green-limit" [inputValue]="courseList[1].EdgeGreensLimit"
                    (updatedValue)="updateEdgeGreensLimit($event, courseList[1].CourseId)" [label]="'EDGE GREENS'"
                    [steps]="1" [page]="'grid'" color="white">
                </app-day-stimp-range> -->
            </div>
        </div>
        <div [ngClass]="{'pin-table-container' : page == 'pinsheet' && !user && showTables}">
            <mat-grid-list cols="3" rowHeight="{{rowHeight}}" gutterSize="-1px" [ngClass]="{'reduce-grid-width' : page == 'pinsheet' && !user && showTables, 'disable-pointer-events': isClubCarClient}">
                <div *ngIf="summaryData.HasPinsheet">
                    <mat-grid-tile *ngFor="let green of has27Course2"  [ngClass]="{'selected': (selectedGreen === green.Name && isApacheCourse && isShowDetails)}" (click)="redirectPinsheetDetails()">
                        <div class="green" [attr.data-greenname]="green.Id">
                            <img src="{{'data:image/jpg;base64,'+green.Image}}" class="green_image "
                                [routerLink]="getPinsheetDetailsLink(green.PinsheetID, green.Id, courseList[1].CourseID)"
                                 [queryParams]="page!='externalPinsheet' ? {} : {accessKey: externalAccessKey}">
                            <div class="green_holeid ">
                                <p [ngClass]="{'highlight': green.HasEdgeHole && page!='externalPinsheet',
                                               'forced': colorIndication && (green.EdgeHoleSelectionReason == 'Forced' || green.EdgeHoleSelectionReason == 'LimitForced'),
                                               'manual': colorIndication && green.EdgeHoleSelectionReason == 'Manual',
                                               'grey-dotted-circle': colorIndication && green.EdgeHoleSelectionReason == 'LimitReverted',
                                               'pointer': page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null}"
                                    [tooltip]="(page!='externalPinsheet' && colorIndication && isDesktop) ? getEdgeHoleTooltipMessage[green.EdgeHoleSelectionReason] : null"
                                    [tooltipPlacement]="'auto'"
                                    [container]="'body'"
                                    [containerClass]="'color-indication-tooltip'"
                                    (click)="(page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null) ? openColorIndicationLegendDialog() : null">
                                    {{green.Name}}
                                </p>
                            </div>
                            <div class="green_position">
                                <p>D: {{green.Depth}}
                                </p>
                            </div>
                            <div class="green_holecenter">
                                <p>{{green.Center || 'X'}}
                                </p>
                            </div>
                            <div class="hole_pos">
                                <p *ngIf="green.Position != null ||  green.Position !=''">{{green.Position}}</p>
                                <p *ngIf="green.Position == null ||  green.Position ==''"
                                    style="color:rgb(192,0,0);">
                                    {{'Select Hole'}}</p>
                            </div>
                            <div [style]="{ position: 'absolute', top: 25 + (5 - getGreenTeeBoxes(green.Id).length) * 5 + '%', left: 0 }" *ngIf="teeBoxData.length> 0 && showTeeBoxDistance && green.Position != null && green.Position != ''">
                                <table style="border: 1px solid black;">
                                    <tr *ngFor="let teeBox of getGreenTeeBoxes(green.Id)">
                                        <p style="color: #01395d; font-size: min(2.4vw, 0.75rem); padding: 0px 1px; margin: 0px; line-height: min(4vw, 20px);" *ngIf="teeBox.IsActive">{{getTeeBoxDistance(teeBox.Distance, green.Center)}}</p>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="hole_stimp" *ngIf="page == 'pinsheet' && !user && green.Position && showStimp" [ngStyle]="{'background-color': green.StimpColor}">
                            <p>
                                {{green.StimpValue}}%
                            </p>
                        </div>
                        <div *ngIf="isApacheCourse" class="details" (click)="showDetails(green.Name, 'zoneDetails-5')">
                            <p>Details</p>
                        </div>
                    </mat-grid-tile>
                </div>
            </mat-grid-list>
            <div class="hole-tables" *ngIf="page == 'pinsheet' && showTables">
                <div *ngIf="isApacheCourse" class="green-details-container" id="zoneDetails-5"  style="display: none;">
                    <p class="green-details-heading">GREEN {{hoveredGreenName}}</p>
                    <div class="green-text-container">
                        <div>
                            <p class="green-text" >MOISTURE</p>
                            <p class="green-values">{{moistureValue}} %</p>
                        </div>
                        <div>
                            <p class="green-text" >EC</p>
                            <p class="green-values">{{ecValue}} dS/m</p>
                        </div>
                        <div>
                            <p class="green-text" >SALINITY INDEX</p>
                            <p class="green-values">{{salinityIndexValue}}</p>
                        </div>
                        <div>
                            <p class="green-text" >SURFACE HEAT</p>
                            <p class="green-values">{{surfaceHeatValue}} F</p>
                        </div>
                        <div>
                            <p class="green-text" >SOIL TEMP</p>
                            <p class="green-values">{{soilTempValue}} F</p>
                        </div>
                    </div>
                </div>
                <app-hole-position-tables *ngIf="page == 'pinsheet' && !user && showTables" class="hole-tables" 
                    [hasPinsheet]="summaryData.HasPinsheet" [greenList]="has27Course2">
                </app-hole-position-tables>
            </div>
        </div>
    </div>
    <div class="marginRight10">
        <div *ngIf="summaryData.HasPinsheet" class="grid-title">
            <p class="pinsheet_title">{{courseList[2].CourseName}}</p>
            <div class="dv-edge-greens">
                <p class="pinsheet_title" *ngIf="page == 'pinsheet' && !user">Distance Variance : {{summaryData.DistanceVariance[2]}}</p>
                <!-- <app-day-stimp-range class="edge-green-limit" [inputValue]="courseList[2].EdgeGreensLimit"
                    (updatedValue)="updateEdgeGreensLimit($event, courseList[2].CourseId)" [label]="'EDGE GREENS'"
                    [steps]="1" [page]="'grid'" color="white">
                </app-day-stimp-range> -->
            </div>
        </div>
        <div [ngClass]="{'pin-table-container' : page == 'pinsheet' && !user && showTables}">
            <mat-grid-list cols="3" rowHeight="{{rowHeight}}" gutterSize="-1px" [ngClass]="{'reduce-grid-width' : page == 'pinsheet' && !user && showTables, 'disable-pointer-events': isClubCarClient}">
                <div *ngIf="summaryData.HasPinsheet">
                    <mat-grid-tile *ngFor="let green of has27Course3"  [ngClass]="{'selected': (selectedGreen === green.Name && isApacheCourse && isShowDetails)}" (click)="redirectPinsheetDetails()" >
                        <div class="green" [attr.data-greenname]="green.Id">
                            <img src="{{'data:image/jpg;base64,'+green.Image}}" class="green_image "
                                [routerLink]="getPinsheetDetailsLink(green.PinsheetID, green.Id, courseList[2].CourseID)"
                                [queryParams]="page!='externalPinsheet' ? {} : {accessKey: externalAccessKey}">
                            <div class="green_holeid ">
                                <p [ngClass]="{'highlight': green.HasEdgeHole && page!='externalPinsheet',
                                               'forced': colorIndication && (green.EdgeHoleSelectionReason == 'Forced' || green.EdgeHoleSelectionReason == 'LimitForced'),
                                               'manual': colorIndication && green.EdgeHoleSelectionReason == 'Manual',
                                               'grey-dotted-circle': colorIndication && green.EdgeHoleSelectionReason == 'LimitReverted',
                                               'pointer': page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null}"
                                    [tooltip]="(page!='externalPinsheet' && colorIndication && isDesktop) ? getEdgeHoleTooltipMessage[green.EdgeHoleSelectionReason] : null"
                                    [tooltipPlacement]="'auto'"
                                    [container]="'body'"
                                    [containerClass]="'color-indication-tooltip'"
                                    (click)="(page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null) ? openColorIndicationLegendDialog() : null">
                                    {{green.Name}}
                                </p>
                            </div>
                            <div class="green_position">
                                <p>D: {{green.Depth}}
                                </p>
                            </div>
                            <div class="green_holecenter">
                                <p>{{green.Center || 'X'}}
                                </p>
                            </div>
                            <div class="hole_pos">
                                <p *ngIf="green.Position != null ||  green.Position !=''">{{green.Position}}</p>
                                <p *ngIf="green.Position == null ||  green.Position ==''"
                                    style="color:rgb(192,0,0);">
                                    {{'Select Hole'}}</p>
                            </div>
                            <div [style]="{ position: 'absolute', top: 25 + (5 - getGreenTeeBoxes(green.Id).length) * 5 + '%', left: 0 }" *ngIf="teeBoxData.length> 0 && showTeeBoxDistance && green.Position != null && green.Position != ''">
                                <table style="border: 1px solid black;">
                                    <tr *ngFor="let teeBox of getGreenTeeBoxes(green.Id)">
                                        <p style="color: #01395d; font-size: min(2.4vw, 0.75rem); padding: 0px 1px; margin: 0px; line-height: min(4vw, 20px);" *ngIf="teeBox.IsActive">{{getTeeBoxDistance(teeBox.Distance, green.Center)}}</p>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="hole_stimp" *ngIf="page == 'pinsheet' && !user && green.Position && showStimp" [ngStyle]="{'background-color': green.StimpColor}">
                            <p>
                                {{green.StimpValue}}%
                            </p>
                        </div>
                        <div *ngIf="isApacheCourse" class="details" (click)="showDetails(green.Name, 'zoneDetails-6')">
                            <p>Details</p>
                        </div>
                    </mat-grid-tile>
                </div>
            </mat-grid-list>
            <div class="hole-tables" *ngIf="page == 'pinsheet' && showTables">
                <div *ngIf="isApacheCourse" class="green-details-container" id="zoneDetails-6"  style="display: none;">
                    <p class="green-details-heading">GREEN {{hoveredGreenName}}</p>
                    <div class="green-text-container">
                        <div>
                            <p class="green-text" >MOISTURE</p>
                            <p class="green-values">{{moistureValue}} %</p>
                        </div>
                        <div>
                            <p class="green-text" >EC</p>
                            <p class="green-values">{{ecValue}} dS/m</p>
                        </div>
                        <div>
                            <p class="green-text" >SALINITY INDEX</p>
                            <p class="green-values">{{salinityIndexValue}}</p>
                        </div>
                        <div>
                            <p class="green-text" >SURFACE HEAT</p>
                            <p class="green-values">{{surfaceHeatValue}} F</p>
                        </div>
                        <div>
                            <p class="green-text" >SOIL TEMP</p>
                            <p class="green-values">{{soilTempValue}} F</p>
                        </div>
                    </div>
                </div>
                <app-hole-position-tables *ngIf="page == 'pinsheet' && !user && showTables" class="hole-tables" 
                    [hasPinsheet]="summaryData.HasPinsheet" [greenList]="has27Course3">
                </app-hole-position-tables>
            </div>
        </div>
    </div>
</div>
<div *ngIf="has36Green && isGroupedCourse" id="has36Green" class="specialPinsheetGrid" [ngClass]="{'single-grid' : page == 'pinsheet' && !user}">
    <div class="marginRight10" style="page-break-after: always !important;">
        <div *ngIf="summaryData.HasPinsheet" class="grid-title">
            <p class="pinsheet_title">{{courseList[0].CourseName}}</p>
            <div class="dv-edge-greens">
                <p class="pinsheet_title" *ngIf="page == 'pinsheet' && !user">Distance Variance : {{summaryData.DistanceVariance[0]}}</p>
                <!-- <app-day-stimp-range class="edge-green-limit" [inputValue]="courseList[0].EdgeGreensLimit"
                    (updatedValue)="updateEdgeGreensLimit($event, courseList[0].CourseId)" [label]="'EDGE GREENS'"
                    [steps]="1" [page]="'grid'" color="white">
                </app-day-stimp-range> -->
            </div>
        </div>
        <div [ngClass]="{'pin-table-container' : page == 'pinsheet' && !user && showTables}">
            <mat-grid-list cols="3" rowHeight="{{rowHeight}}" gutterSize="-1px" [ngClass]="{'reduce-grid-width' : page == 'pinsheet' && !user && showTables, 'disable-pointer-events': isClubCarClient}">
                <div *ngIf="summaryData.HasPinsheet">
                    <mat-grid-tile *ngFor="let green of has36Course1" [ngClass]="{'selected': (selectedGreen === green.Name && isApacheCourse && isShowDetails)}" (click)="redirectPinsheetDetails()" >
                        <div class="green" [attr.data-greenname]="green.Id">
                            <img src="{{'data:image/jpg;base64,'+green.Image}}" class="green_image " 
                                [routerLink]="getPinsheetDetailsLink(green.PinsheetID, green.Id, courseList[0].CourseID)"
                                [queryParams]="page!='externalPinsheet' ? {} : {accessKey: externalAccessKey}">
                            <div class="green_holeid ">
                                <p [ngClass]="{'highlight': green.HasEdgeHole && page!='externalPinsheet',
                                               'forced': colorIndication && (green.EdgeHoleSelectionReason == 'Forced' || green.EdgeHoleSelectionReason == 'LimitForced'),
                                               'manual': colorIndication && green.EdgeHoleSelectionReason == 'Manual',
                                               'grey-dotted-circle': colorIndication && green.EdgeHoleSelectionReason == 'LimitReverted',
                                               'pointer': page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null}"
                                    [tooltip]="(page!='externalPinsheet' && colorIndication && isDesktop) ? getEdgeHoleTooltipMessage[green.EdgeHoleSelectionReason] : null"
                                    [tooltipPlacement]="'auto'"
                                    [container]="'body'"
                                    [containerClass]="'color-indication-tooltip'"
                                    (click)="(page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null) ? openColorIndicationLegendDialog() : null">
                                    {{green.Name}}
                                </p>
                            </div>
                            <div class="green_position">
                                <p>D: {{green.Depth}}
                                </p>
                            </div>
                            <div class="green_holecenter">
                                <p>{{green.Center || 'X'}}
                                </p>
                            </div>
                            <div class="hole_pos">
                                <p *ngIf="green.Position != null ||  green.Position !=''">{{green.Position}}</p>
                                <p *ngIf="green.Position == null ||  green.Position ==''"
                                    style="color:rgb(192,0,0);">
                                    {{'Select Hole'}}</p>
                            </div>
                            <div [style]="{ position: 'absolute', top: 25 + (5 - getGreenTeeBoxes(green.Id).length) * 5 + '%', left: 0 }" *ngIf="teeBoxData.length> 0 && showTeeBoxDistance && green.Position != null && green.Position != ''">
                                <table style="border: 1px solid black;">
                                    <tr *ngFor="let teeBox of getGreenTeeBoxes(green.Id)">
                                        <p style="color: #01395d; font-size: min(2.4vw, 0.75rem); padding: 0px 1px; margin: 0px; line-height: min(4vw, 20px);" *ngIf="teeBox.IsActive">{{getTeeBoxDistance(teeBox.Distance, green.Center)}}</p>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="hole_stimp" *ngIf="page == 'pinsheet' && !user && green.Position && showStimp" [ngStyle]="{'background-color': green.StimpColor}">
                            <p>
                                {{green.StimpValue}}%
                            </p>
                        </div>
                        <div *ngIf="isApacheCourse" class="details" (click)="showDetails(green.Name, 'zoneDetails-7')">
                            <p>Details</p>
                        </div>
                    </mat-grid-tile>
                </div>
            </mat-grid-list>
            <div class="hole-tables" *ngIf="page == 'pinsheet' && showTables">
                <div *ngIf="isApacheCourse" class="green-details-container" id="zoneDetails-7"  style="display: none;">
                    <p class="green-details-heading">GREEN {{hoveredGreenName}}</p>
                    <div class="green-text-container">
                        <div>
                            <p class="green-text" >MOISTURE</p>
                            <p class="green-values">{{moistureValue}} %</p>
                        </div>
                        <div>
                            <p class="green-text" >EC</p>
                            <p class="green-values">{{ecValue}} dS/m</p>
                        </div>
                        <div>
                            <p class="green-text" >SALINITY INDEX</p>
                            <p class="green-values">{{salinityIndexValue}}</p>
                        </div>
                        <div>
                            <p class="green-text" >SURFACE HEAT</p>
                            <p class="green-values">{{surfaceHeatValue}} F</p>
                        </div>
                        <div>
                            <p class="green-text" >SOIL TEMP</p>
                            <p class="green-values">{{soilTempValue}} F</p>
                        </div>
                    </div>
                </div>
                <app-hole-position-tables *ngIf="page == 'pinsheet' && !user && showTables" class="hole-tables" 
                    [hasPinsheet]="summaryData.HasPinsheet" [greenList]="has36Course1">
                </app-hole-position-tables>
            </div>
        </div>
    </div>
    <div>
        <div *ngIf="summaryData.HasPinsheet" class="grid-title">
            <p class="pinsheet_title">{{courseList[1].CourseName}}</p>
            <div class="dv-edge-greens">
                <p class="pinsheet_title" *ngIf="page == 'pinsheet' && !user">Distance Variance : {{summaryData.DistanceVariance[1]}}</p>
                <!-- <app-day-stimp-range class="edge-green-limit" [inputValue]="courseList[1].EdgeGreensLimit"
                    (updatedValue)="updateEdgeGreensLimit($event, courseList[1].CourseId)" [label]="'EDGE GREENS'"
                    [steps]="1" [page]="'grid'" color="white">
                </app-day-stimp-range> -->
            </div>
        </div>
        <div [ngClass]="{'pin-table-container' : page == 'pinsheet' && !user && showTables}">
            <mat-grid-list cols="3" rowHeight="{{rowHeight}}" gutterSize="-1px" [ngClass]="{'reduce-grid-width' : page == 'pinsheet' && !user && showTables, 'disable-pointer-events': isClubCarClient}">
                <div *ngIf="summaryData.HasPinsheet">
                    <mat-grid-tile *ngFor="let green of has36Course2" [ngClass]="{'selected': (selectedGreen === green.Name && isApacheCourse && isShowDetails)}" (click)="redirectPinsheetDetails()" >
                        <div class="green" [attr.data-greenname]="green.Id">
                            <img src="{{'data:image/jpg;base64,'+green.Image}}" class="green_image "
                                [routerLink]="getPinsheetDetailsLink(green.PinsheetID, green.Id, courseList[1].CourseID)"
                                 [queryParams]="page!='externalPinsheet' ? {} : {accessKey: externalAccessKey}">
                            <div class="green_holeid ">
                                <p [ngClass]="{'highlight': green.HasEdgeHole && page!='externalPinsheet',
                                               'forced': colorIndication && (green.EdgeHoleSelectionReason == 'Forced' || green.EdgeHoleSelectionReason == 'LimitForced'),
                                               'manual': colorIndication && green.EdgeHoleSelectionReason == 'Manual',
                                               'grey-dotted-circle': colorIndication && green.EdgeHoleSelectionReason == 'LimitReverted',
                                               'pointer': page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null}"
                                    [tooltip]="(page!='externalPinsheet' && colorIndication && isDesktop) ? getEdgeHoleTooltipMessage[green.EdgeHoleSelectionReason] : null"
                                    [tooltipPlacement]="'auto'"
                                    [container]="'body'"
                                    [containerClass]="'color-indication-tooltip'"
                                    (click)="(page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null) ? openColorIndicationLegendDialog() : null">
                                    {{green.Name}}
                                </p>
                            </div>
                            <div class="green_position">
                                <p>D: {{green.Depth}}
                                </p>
                            </div>
                            <div class="green_holecenter">
                                <p>{{green.Center || 'X'}}
                                </p>
                            </div>
                            <div class="hole_pos">
                                <p *ngIf="green.Position != null ||  green.Position !=''">{{green.Position}}</p>
                                <p *ngIf="green.Position == null ||  green.Position ==''"
                                    style="color:rgb(192,0,0);">
                                    {{'Select Hole'}}</p>
                            </div>
                            <div [style]="{ position: 'absolute', top: 25 + (5 - getGreenTeeBoxes(green.Id).length) * 5 + '%', left: 0 }" *ngIf="teeBoxData.length> 0 && showTeeBoxDistance && green.Position != null && green.Position != ''">
                                <table style="border: 1px solid black;">
                                    <tr *ngFor="let teeBox of getGreenTeeBoxes(green.Id)">
                                        <p style="color: #01395d; font-size: min(2.4vw, 0.75rem); padding: 0px 1px; margin: 0px; line-height: min(4vw, 20px);" *ngIf="teeBox.IsActive">{{getTeeBoxDistance(teeBox.Distance, green.Center)}}</p>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="hole_stimp" *ngIf="page == 'pinsheet' && !user && green.Position && showStimp" [ngStyle]="{'background-color': green.StimpColor}">
                            <p>
                                {{green.StimpValue}}%
                            </p>
                        </div>
                        <div *ngIf="isApacheCourse" class="details" (click)="showDetails(green.Name, 'zoneDetails-8')">
                            <p>Details</p>
                        </div>
                    </mat-grid-tile>
                </div>
            </mat-grid-list>
            <div class="hole-tables" *ngIf="page == 'pinsheet' && showTables">
                <div *ngIf="isApacheCourse" class="green-details-container" id="zoneDetails-8"  style="display: none;">
                    <p class="green-details-heading">GREEN {{hoveredGreenName}}</p>
                    <div class="green-text-container">
                        <div>
                            <p class="green-text" >MOISTURE</p>
                            <p class="green-values">{{moistureValue}} %</p>
                        </div>
                        <div>
                            <p class="green-text" >EC</p>
                            <p class="green-values">{{ecValue}} dS/m</p>
                        </div>
                        <div>
                            <p class="green-text" >SALINITY INDEX</p>
                            <p class="green-values">{{salinityIndexValue}}</p>
                        </div>
                        <div>
                            <p class="green-text" >SURFACE HEAT</p>
                            <p class="green-values">{{surfaceHeatValue}} F</p>
                        </div>
                        <div>
                            <p class="green-text" >SOIL TEMP</p>
                            <p class="green-values">{{soilTempValue}} F</p>
                        </div>
                    </div>
                </div>
                <app-hole-position-tables *ngIf="page == 'pinsheet' && !user && showTables" class="hole-tables" 
                    [hasPinsheet]="summaryData.HasPinsheet" [greenList]="has36Course2">
                </app-hole-position-tables>
            </div>
        </div>
    </div>
    <div class="marginRight10">
        <div *ngIf="summaryData.HasPinsheet" class="grid-title">
            <p class="pinsheet_title">{{courseList[2].CourseName}}</p>
            <div class="dv-edge-greens">
                <p class="pinsheet_title" *ngIf="page == 'pinsheet' && !user">Distance Variance : {{summaryData.DistanceVariance[2]}}</p>
                <!-- <app-day-stimp-range class="edge-green-limit" [inputValue]="courseList[2].EdgeGreensLimit"
                    (updatedValue)="updateEdgeGreensLimit($event, courseList[2].CourseId)" [label]="'EDGE GREENS'"
                    [steps]="1" [page]="'grid'" color="white">
                </app-day-stimp-range> -->
            </div>
        </div>
        <div [ngClass]="{'pin-table-container' : page == 'pinsheet' && !user && showTables}">
            <mat-grid-list cols="3" rowHeight="{{rowHeight}}" gutterSize="-1px" [ngClass]="{'reduce-grid-width' : page == 'pinsheet' && !user && showTables, 'disable-pointer-events': isClubCarClient}">
                <div *ngIf="summaryData.HasPinsheet">
                    <mat-grid-tile *ngFor="let green of has36Course3" [ngClass]="{'selected': (selectedGreen === green.Name && isApacheCourse && isShowDetails)}" (click)="redirectPinsheetDetails()">
                        <div class="green" [attr.data-greenname]="green.Id">
                            <img src="{{'data:image/jpg;base64,'+green.Image}}" class="green_image "
                                [routerLink]="getPinsheetDetailsLink(green.PinsheetID, green.Id, courseList[2].CourseID)"
                                 [queryParams]="page!='externalPinsheet' ? {} : {accessKey: externalAccessKey}">
                            <div class="green_holeid ">
                                <p [ngClass]="{'highlight': green.HasEdgeHole && page!='externalPinsheet',
                                               'forced': colorIndication && (green.EdgeHoleSelectionReason == 'Forced' || green.EdgeHoleSelectionReason == 'LimitForced'),
                                               'manual': colorIndication && green.EdgeHoleSelectionReason == 'Manual',
                                               'grey-dotted-circle': colorIndication && green.EdgeHoleSelectionReason == 'LimitReverted',
                                               'pointer': page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null}"
                                    [tooltip]="(page!='externalPinsheet' && colorIndication && isDesktop) ? getEdgeHoleTooltipMessage[green.EdgeHoleSelectionReason] : null"
                                    [tooltipPlacement]="'auto'"
                                    [container]="'body'"
                                    [containerClass]="'color-indication-tooltip'"
                                    (click)="(page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null) ? openColorIndicationLegendDialog() : null">
                                    {{green.Name}}
                                </p>
                            </div>
                            <div class="green_position">
                                <p>D: {{green.Depth}}
                                </p>
                            </div>
                            <div class="green_holecenter">
                                <p>{{green.Center || 'X'}}
                                </p>
                            </div>
                            <div class="hole_pos">
                                <p *ngIf="green.Position != null ||  green.Position !=''">{{green.Position}}</p>
                                <p *ngIf="green.Position == null ||  green.Position ==''"
                                    style="color:rgb(192,0,0);">
                                    {{'Select Hole'}}</p>
                            </div>
                            <div [style]="{ position: 'absolute', top: 25 + (5 - getGreenTeeBoxes(green.Id).length) * 5 + '%', left: 0 }" *ngIf="teeBoxData.length> 0 && showTeeBoxDistance && green.Position != null && green.Position != ''">
                                <table style="border: 1px solid black;">
                                    <tr *ngFor="let teeBox of getGreenTeeBoxes(green.Id)">
                                        <p style="color: #01395d; font-size: min(2.4vw, 0.75rem); padding: 0px 1px; margin: 0px; line-height: min(4vw, 20px);" *ngIf="teeBox.IsActive">{{getTeeBoxDistance(teeBox.Distance, green.Center)}}</p>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="hole_stimp" *ngIf="page == 'pinsheet' && !user && green.Position && showStimp" [ngStyle]="{'background-color': green.StimpColor}">
                            <p>
                                {{green.StimpValue}}%
                            </p>
                        </div>
                        <div *ngIf="isApacheCourse" class="details" (click)="showDetails(green.Name, 'zoneDetails-9')">
                            <p>Details</p>
                        </div>
                    </mat-grid-tile>
                </div>
            </mat-grid-list>
            <div class="hole-tables" *ngIf="page == 'pinsheet' && showTables">
                <div *ngIf="isApacheCourse" class="green-details-container" id="zoneDetails-9"  style="display: none;">
                    <p class="green-details-heading">GREEN {{hoveredGreenName}}</p>
                    <div class="green-text-container">
                        <div>
                            <p class="green-text" >MOISTURE</p>
                            <p class="green-values">{{moistureValue}} %</p>
                        </div>
                        <div>
                            <p class="green-text" >EC</p>
                            <p class="green-values">{{ecValue}} dS/m</p>
                        </div>
                        <div>
                            <p class="green-text" >SALINITY INDEX</p>
                            <p class="green-values">{{salinityIndexValue}}</p>
                        </div>
                        <div>
                            <p class="green-text" >SURFACE HEAT</p>
                            <p class="green-values">{{surfaceHeatValue}} F</p>
                        </div>
                        <div>
                            <p class="green-text" >SOIL TEMP</p>
                            <p class="green-values">{{soilTempValue}} F</p>
                        </div>
                    </div>
                </div>
                <app-hole-position-tables *ngIf="page == 'pinsheet' && !user && showTables" class="hole-tables" 
                    [hasPinsheet]="summaryData.HasPinsheet" [greenList]="has36Course3">
                </app-hole-position-tables>
            </div>
        </div>
    </div>
    <div>
        <div *ngIf="summaryData.HasPinsheet" class="grid-title">
            <p class="pinsheet_title">{{courseList[3].CourseName}}</p>
            <div class="dv-edge-greens">
                <p class="pinsheet_title" *ngIf="page == 'pinsheet' && !user">Distance Variance : {{summaryData.DistanceVariance[3]}}</p>
                <!-- <app-day-stimp-range class="edge-green-limit" [inputValue]="courseList[3].EdgeGreensLimit"
                    (updatedValue)="updateEdgeGreensLimit($event, courseList[3].CourseId)" [label]="'EDGE GREENS'"
                    [steps]="1" [page]="'grid'" color="white">
                </app-day-stimp-range> -->
            </div>
        </div>
        <div [ngClass]="{'pin-table-container' : page == 'pinsheet' && !user && showTables}">
            <mat-grid-list cols="3" rowHeight="{{rowHeight}}" gutterSize="-1px" [ngClass]="{'reduce-grid-width' : page == 'pinsheet' && !user && showTables, 'disable-pointer-events': isClubCarClient}">
                <div *ngIf="summaryData.HasPinsheet">
                    <mat-grid-tile *ngFor="let green of has36Course4" [ngClass]="{'selected': (selectedGreen === green.Name && isApacheCourse && isShowDetails)}" (click)="redirectPinsheetDetails()">
                        <div class="green" [attr.data-greenname]="green.Id">
                            <img src="{{'data:image/jpg;base64,'+green.Image}}" class="green_image "
                                [routerLink]="getPinsheetDetailsLink(green.PinsheetID, green.Id, courseList[3].CourseID)"
                                 [queryParams]="page!='externalPinsheet' ? {} : {accessKey: externalAccessKey}">
                            <div class="green_holeid ">
                                <p [ngClass]="{'highlight': green.HasEdgeHole && page!='externalPinsheet',
                                               'forced': colorIndication && (green.EdgeHoleSelectionReason == 'Forced' || green.EdgeHoleSelectionReason == 'LimitForced'),
                                               'manual': colorIndication && green.EdgeHoleSelectionReason == 'Manual',
                                               'grey-dotted-circle': colorIndication && green.EdgeHoleSelectionReason == 'LimitReverted',
                                               'pointer': page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null}"
                                    [tooltip]="(page!='externalPinsheet' && colorIndication && isDesktop) ? getEdgeHoleTooltipMessage[green.EdgeHoleSelectionReason] : null"
                                    [tooltipPlacement]="'auto'"
                                    [container]="'body'"
                                    [containerClass]="'color-indication-tooltip'"
                                    (click)="(page!='externalPinsheet' && colorIndication && green.EdgeHoleSelectionReason != null) ? openColorIndicationLegendDialog() : null">
                                    {{green.Name}}
                                </p>
                            </div>
                            <div class="green_position">
                                <p>D: {{green.Depth}}
                                </p>
                            </div>
                            <div class="green_holecenter">
                                <p>{{green.Center || 'X'}}
                                </p>
                            </div>
                            <div class="hole_pos">
                                <p *ngIf="green.Position != null ||  green.Position !=''">{{green.Position}}</p>
                                <p *ngIf="green.Position == null ||  green.Position ==''"
                                    style="color:rgb(192,0,0);">
                                    {{'Select Hole'}}</p>
                            </div>
                            <div [style]="{ position: 'absolute', top: 25 + (5 - getGreenTeeBoxes(green.Id).length) * 5 + '%', left: 0 }" *ngIf="teeBoxData.length> 0 && showTeeBoxDistance && green.Position != null && green.Position != ''">
                                <table style="border: 1px solid black;">
                                    <tr *ngFor="let teeBox of getGreenTeeBoxes(green.Id)">
                                        <p style="color: #01395d; font-size: min(2.4vw, 0.75rem); padding: 0px 1px; margin: 0px; line-height: min(4vw, 20px);" *ngIf="teeBox.IsActive">{{getTeeBoxDistance(teeBox.Distance, green.Center)}}</p>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="hole_stimp" *ngIf="page == 'pinsheet' && !user && green.Position && showStimp" [ngStyle]="{'background-color': green.StimpColor}">
                            <p>
                                {{green.StimpValue}}%
                            </p>
                        </div>
                        <div *ngIf="isApacheCourse" class="details" (click)="showDetails(green.Name, 'zoneDetails-10')">
                            <p>Details</p>
                        </div>
                    </mat-grid-tile>
                </div>
            </mat-grid-list>
            <div class="hole-tables" *ngIf="page == 'pinsheet' && showTables">
                <div *ngIf="isApacheCourse" class="green-details-container" id="zoneDetails-10"  style="display: none;">
                    <p class="green-details-heading">GREEN {{hoveredGreenName}}</p>
                    <div class="green-text-container">
                        <div>
                            <p class="green-text" >MOISTURE</p>
                            <p class="green-values">{{moistureValue}} %</p>
                        </div>
                        <div>
                            <p class="green-text" >EC</p>
                            <p class="green-values">{{ecValue}} dS/m</p>
                        </div>
                        <div>
                            <p class="green-text" >SALINITY INDEX</p>
                            <p class="green-values">{{salinityIndexValue}}</p>
                        </div>
                        <div>
                            <p class="green-text" >SURFACE HEAT</p>
                            <p class="green-values">{{surfaceHeatValue}} F</p>
                        </div>
                        <div>
                            <p class="green-text" >SOIL TEMP</p>
                            <p class="green-values">{{soilTempValue}} F</p>
                        </div>
                    </div>
                </div>
                <app-hole-position-tables *ngIf="page == 'pinsheet' && !user && showTables" class="hole-tables" 
                    [hasPinsheet]="summaryData.HasPinsheet" [greenList]="has36Course4">
                </app-hole-position-tables>
            </div>
        </div>
    </div>
</div>

<ng-template #colorIndicationLegend>
    <h3 mat-dialog-title class="legend-title">Color Indication Legend:</h3>
    <div class="color-indication-legend-container">
       <div>
           <p class="highlight"></p>
           <p class="info">{{getEdgeHoleTooltipMessage['Limit']}}</p>
       </div>
       <div>
           <p class="highlight forced"></p>
           <p class="info">{{getEdgeHoleTooltipMessage['Forced']}}</p>
       </div>
       <div>
           <p class="highlight manual"></p>
           <p class="info">{{getEdgeHoleTooltipMessage['Manual']}}</p>
       </div>
       <div>
           <p class="grey-dotted-circle"></p>
           <p class="info">{{getEdgeHoleTooltipMessage['LimitReverted']}}</p>
       </div>
    </div>
    <div mat-dialog-actions>
        <button class="btn pop-up-button theme-button" mat-dialog-close>OK</button>
    </div>
</ng-template>